import React from "react";
import { Heart, Sun, Home, Smile } from "lucide-react";
import { bannerItems } from "../mock";

const iconMap = { Sun, Home, Smile };

export default function Benefits() {
  return (
    <section id="why" className="bg-[#615DD2]">
      <div className="mx-auto flex max-w-7xl flex-col items-stretch gap-6 px-5 py-8 md:px-8 lg:flex-row lg:items-center lg:gap-0">
        {/* Left statement */}
        <div className="flex items-center gap-5 lg:w-[45%] lg:pr-8">
          <Heart className="h-12 w-12 shrink-0 text-[#48B6F7]" strokeWidth={1.6} />
          <p className="font-serif-display text-lg font-semibold leading-snug text-white md:text-xl">
            For overwhelmed parents who want calmer days and confident kids—starting
            right where they are.
          </p>
        </div>

        {/* Right items */}
        <div className="grid flex-1 grid-cols-1 sm:grid-cols-3 lg:border-l lg:border-white/25">
          {bannerItems.map((b, i) => {
            const Icon = iconMap[b.icon];
            return (
              <div
                key={b.label}
                className={`flex flex-col items-center gap-2.5 px-6 py-3 text-center ${
                  i < bannerItems.length - 1 ? "sm:border-r sm:border-white/25" : ""
                }`}
              >
                <Icon className="h-8 w-8 text-white" strokeWidth={1.6} />
                <span className="whitespace-pre-line text-[13px] font-extrabold leading-tight text-white">
                  {b.label}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
